/**
 * Brand values ported from the C# ProductContext
 * (src/LoadAndFlow.Core/Domain/Tenant/ProductContext.cs).
 *
 * There, one codebase served both Load & Flow and Hillory, so every value was
 * a switch on the active product. This SPA is Load & Flow only, so the
 * Load & Flow branch is inlined — but the values are kept together here rather
 * than scattered through the markup, so the Hillory port has an obvious seam.
 */
export const BRAND = {
  name: "Load & Flow",
  logoPath: "/lf/logo.png",
  iconPrefix: "/lf",
  domain: "loadandflow.com",
  themeColor: "#059669",
  metaDescription:
    "Kettlebell training education with personalised session suggestions. Exercise library with video, progress tracking. Free during beta.",
  footerDisclaimer:
    "Load & Flow provides kettlebell training education and personalised suggestions.",
  sisterBrandName: "Hillory",
  sisterDomain: "hillory.run",
  sisterTagline: "Strength for the Long Run",
} as const;
